import { render, staticRenderFns } from "./personalwithdrawal.vue?vue&type=template&id=99c9cef6&scoped=true"
import script from "./personalwithdrawal.vue?vue&type=script&lang=js"
export * from "./personalwithdrawal.vue?vue&type=script&lang=js"
import style0 from "./personalwithdrawal.vue?vue&type=style&index=0&id=99c9cef6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c9cef6",
  null
  
)

export default component.exports